<template>
  <div class="users-block users">
    <preloader :visible="preloader" />
    <v-server-table ref="vuetable" :url="route" :columns="columns" :options="options" @loading="onLoading" @loaded="onLoaded" class="custom-table-modifier">
      <template v-slot:id="ctx"><a :href="`/user/${ctx.row.id}`">{{ ctx.row.id }}</a></template>
      <template v-slot:role="ctx">
        <div v-if="ctx.row.roles"><span v-for="(role) in ctx.row.roles" :key="role.id" class="margin-inline">{{ role.name }}</span></div>
      </template>
      <template v-slot:last_login="ctx">
        <strong style="color:#46be8a" v-if="ctx.row.last_login && ctx.row.last_login.login_at">{{ momentVue(ctx.row.last_login.login_at).format(dateFormat) }}<br>{{ ctx.row.last_login.login_ip }}</strong>
        <strong style="color:#fb434a" v-if="!ctx.row.last_login">Never</strong>
      </template>
      <template v-slot:is_enabled="ctx">
        <strong style="color:#46be8a" v-if="ctx.row.is_enabled">Yes</strong>
        <strong style="color:#fb434a" v-if="!ctx.row.is_enabled">No</strong>
      </template>
      <template v-slot:actions="ctx" class="actions-bts" style="text-align: right; padding-bottom: 5px">
        <a v-if="canDelete" class="mr-2 mb-2 btn btn-sm btn-danger" v-on:click="tryDelete(ctx.row.id)"><i class="icmn-bin" aria-hidden="true"></i></a>
        <a v-if="canEdit" :href="`/user/${ctx.row.id}/edit`" class="mr-2 mb-2 btn btn-sm btn-primary"><i class="icmn-pencil3" aria-hidden="true"></i></a>
        <a v-if="canEdit" class="mr-2 mb-2 btn btn-sm btn-default" v-on:click="toggleIsActive(!ctx.row.is_enabled, ctx.row.id)">{{ctx.row.is_enabled ? 'Disable' : 'Enable'}}</a>
      </template>
    </v-server-table>
  </div>
</template>

<script>
import Preloader from "./blocks/preloader";

export default {
  components: { Preloader },
  props: {
    route: {
      type: String
    },
    dateFormat: {
      type: String,
      default: 'MM-DD-YYYY'
    },
    appUrl: {
      type: String,
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      preloader: false,
      columns: ['id', 'name', 'email', 'is_enabled', 'phone', 'role', 'last_login', 'actions'],
      options: {
        filterByColumn: true,
        debounce: 1000,
        requestFunction: (data) => {
          return axios.get(this.route, { params: data });
        },
        dateFormat: this.dateFormat,
        datepickerOptions: {
          showDropdowns: true,
          autoUpdateInput: true,
        },
        orderBy: {
          ascending: false,
        },
        sortable: [],
        filterable: [ 'id', 'name', 'email', 'is_enabled', 'phone', 'role', 'last_login_at' ],
        perPage: 30,
        pagination: {
          chunk:30,
          dropdown:false
        },
        headings: {
          last_login_at: 'Login',
          role: 'Role',
          phone: 'Phone',
          is_enabled: 'Activated',
          email: 'Email',
          name: 'Name',
          id: 'ID',
        },
        listColumns: {
          is_enabled: [{
            id: '1',
            text: 'Yes'
          }, {
            id: '0',
            text: 'No'
          }]
        },
      }
    }
  },
  methods: {
    momentVue(...args) {
      return moment(...args);
    },
    onLoading(e) {
      this.preloader = true;
    },
    onLoaded(e) {
      this.preloader = false;
    },

    toggleIsActive(status, id) {
      const self = this;
      axios.post(`/user/toogle-status/${id}`, { status }).then(response => {
        if (response.data.error) {
          self.toast(response.data.error, 'error');
        } else {
          self.toast(response.data.success);
          this.$refs.vuetable.getData()
        }
      }).catch(e => {
        console.log(e);
        self.toast('Can not update user because of server error.', 'error');
      });
    },

    tryDelete(id) {
      this.$swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this document!',
        icon: 'warning',
        confirmButtonText: 'Delete',
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteItem(id);
        }
      });
    },
    deleteItem(id) {
      const self = this;
      axios.delete(`/user/${id}`).then(response => {
        if (response.data.error) {
          self.toast(response.data.error, 'error');
        } else {
          self.toast(response.data.success);
          this.$refs.vuetable.getData()
        }
      }).catch(e => {
        console.log(e);
        self.toast('User was not deleted because of server error.', 'error');
      });
    },

    toast(message, type) {
      const self = this.$swal;
      self.fire({
        text: message,
        icon: type || 'success',
        toast: true,
        showConfirmButton: false,
        position: 'top-end',
        timer: 1500,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', self.stopTimer)
          toast.addEventListener('mouseleave', self.resumeTimer)
        }
      });
    }
  },
}
</script>

<style>
.users-block .actions-bts > a {
  margin: 2px 0;
}
</style>
